const urlParser = (url, clientId = '', accountId = '', id) => {
  return url
    .replace('{clientId}', clientId)
    .replace('{accountId}', accountId)
    .replace('{id}', id)
}

export {urlParser}
